import { render, staticRenderFns } from "./aClass.vue?vue&type=template&id=28cafa76&scoped=true&"
import script from "./aClass.vue?vue&type=script&lang=js&"
export * from "./aClass.vue?vue&type=script&lang=js&"
import style0 from "./aClass.vue?vue&type=style&index=0&id=28cafa76&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cafa76",
  null
  
)

export default component.exports